import { JoonUIColor, SPACING, Typography } from "@joonapp/web-shared"
import { isAndroid, isMobile } from "react-device-detect"
import { useTranslation } from "react-i18next"

import { useDownloadMobileAppModal } from "../../components/modals/DownloadMobileAppModal"
import useMediaQuery from "../../hooks/useMediaQuery"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../util/analytics"
import { getStoredCountry } from "../../util/country"

const DownloadAppBanner = () => {
  const { onOpen: onOpenDownloadMobileAppModal } = useDownloadMobileAppModal()
  const isSmallScreen = useMediaQuery("(max-width: 600px)")
  const { t } = useTranslation()
  const isFranceAppleBlocked = getStoredCountry()?.toUpperCase() === "FR"

  // App removed from French App Store — nothing to offer iOS users in France
  if (isFranceAppleBlocked && isMobile && !isAndroid) return null

  const handleClick = () => {
    if (isMobile) {
      window.open(
        isAndroid
          ? "https://play.google.com/store/apps/details?id=com.joon.android"
          : "https://apps.apple.com/us/app/joon-behavior-improvement-app/id1482225056",
        "_blank"
      )
    } else {
      onOpenDownloadMobileAppModal()
    }
    trackAnalyticEvent(ANALYTIC_EVENTS.MOBILE_APP_DOWNLOAD_BANNER_CLICK)
  }

  return (
    <button
      onClick={handleClick}
      className="download-app-banner"
      style={{
        position: "sticky",
        top: 0,
        borderBottomLeftRadius: isSmallScreen ? 0 : SPACING.space4,
        borderBottomRightRadius: isSmallScreen ? 0 : SPACING.space4,
        width: "min(100vw, 600px)",
        zIndex: 100,
      }}
    >
      <div
        className={`flex flex-row gap-4 w-full p-4 bg-backgroundPrimary items-center justify-between border-b border-borderPrimary shadow-md ${isSmallScreen ? "" : "rounded-b-md border-l border-r"}`}
      >
        <div className="flex flex-row gap-2 items-center">
          <img
            src="/images/logos/logo_letter.png"
            alt="Joon App"
            className="w-12 h-12"
          />
          <div className="flex flex-col gap-1 items-start">
            <Typography variant="bodyBold" textAlign="left">
              {t("ME_DOWNLOAD_BANNER_TITLE")}
            </Typography>
            <Typography variant="bodySmall" textAlign="left">
              {t("ME_DOWNLOAD_BANNER_SUBTITLE")}
            </Typography>
          </div>
        </div>
        <div className="bg-indigo-500 rounded-md p-1 w-fit h-fit">
          <Typography variant="bodySmall" color={JoonUIColor.text.inverted}>
            {t("ME_DOWNLOAD_BANNER_CTA")}
          </Typography>
        </div>
      </div>
    </button>
  )
}
export default DownloadAppBanner
